import Modal from '../components/_modal';
import fitvid from '../base/_fitvid';

export default class {
	constructor(node) {
		this.node       = node;
		this.poster     = this.node.querySelector('.kcard__poster');
		this.hasModal   = typeof this.node.dataset.modal !== 'undefined';
		this.content    = this.node.querySelector('script[type="text/html"]');
		this.mediaRatio = 0;

		let resize = () => {
			if ( this.media && this.mediaRatio ) {
				this.media.style.width = `${Math.ceil( document.documentElement.clientHeight * this.mediaRatio ) }px`;
			}
		}

		if ( this.content ) {
			let tempDiv = document.createElement('div');
			tempDiv.innerHTML = this.content.innerHTML;

			this.media = tempDiv.querySelector('iframe, video');
			if ( this.media ) {
				switch( this.media.tagName ) {
					case 'VIDEO':
						this.media.setAttribute('autoplay', 'autoplay');
					break;
					case 'IFRAME':
						this.media.src = `${this.media.src}${this.media.src.indexOf('?') === -1 ? '?' : '&'}autoplay=1`;
					break;
				}
			}
			this.mediaContent = tempDiv.innerHTML;

			if ( this.hasModal ) {
				this.mediaRatio = this.media.width / this.media.height;

				this.modal = new Modal( this.mediaContent, {
					closeText: '',
					modifier : 'video',
					target   : this.poster,
					onopen   : () => {
						if ( this.media.tagName === 'VIDEO' ) {
							this.modal.node.querySelector('video').play();
						}
						fitvid();
						resize();
					}
				} );

				this.modal.node.addEventListener( 'transitionend', resize );
				document.body.addEventListener( 'kendal:resize', resize );

				if ( this.poster ) {
					this.poster.addEventListener( 'click', () => this.modal.open() );
				}
			} else if ( this.poster ) {
				this.poster.addEventListener('click', () => {
					this.poster.parentNode.insertAdjacentHTML('beforebegin', this.mediaContent);
					this.poster.parentNode.removeChild(this.poster);

					if ( 'VIDEO' === this.media.tagName ) {
						this.node.querySelector('video').play();
					}
				} );
			}
		}
	}
}
